import React, { Component } from 'react'
import { FormControl, Select, InputLabel, MenuItem, Button, TextField, IconButton, Icon } from '@material-ui/core'
import Http from '../../../Http';
import Autocomplete from '@material-ui/lab/Autocomplete';
import './Preguia.css'
import { objectAsParams } from '../../../helpers';
import PreguiaProductos from './PreguiaProductos'

export default class PreguiaDetalles extends Component {
  state = {
    id_grupo_embalaje: 1,
    paquetes: [],
    pg_observaciones: '',
    pg_peso: '',
    pg_ser_recoleccion: false,
    pg_ser_entrega: false,
    pg_ser_seguro: false,
    pg_valor_declarado: '',
    carga_tipos: [],
    sucursales: [],
    embalajes: [],
    embalaje_grupos: [],
    disabledButton: false,
    searchProducto: {},
    searchProductoOptions: {},
    searchUnidad: {},
    searchUnidadOptions: {},
    showDetailProduct: false,
  }

  componentDidMount() {
    this.getFormData({ eg: 1, initial: true });
    if (this.props.preguia) {
      const preguia = this.props.preguia;
      this.setState({ ...preguia, showDetailProduct: true }) 
    }
  }

  getFormData = async ({eg = null, initial, index, prop}) => {
    let { searchProducto, 
      searchProductoOptions,
      searchUnidad, 
      searchUnidadOptions, 
      carga_tipos,
      embalaje_grupos,
      embalajes,
      sucursales,
    } = this.state;
    let paquetes = false;
    if (this.props.preguia) {
      paquetes = this.props.preguia.paquetes;
    }
    const params = {};
    if (eg) {
      params['eg'] = eg;
    }
    if (initial) {
      params['initial'] = true;
      if (paquetes && paquetes.length > 0) {
        params["clave_productos"] = paquetes
          .filter((paq) => paq.producto_clave)
          .map((paq) => `'${paq.producto_clave}'`)
          .toString();
        params["clave_unidades"] = paquetes
          .filter((paq) => paq.clave_unidad)
          .map((paq) => `'${paq.clave_unidad}'`)
          .toString();
      }
    }
    if (prop === 'pq_id_producto') {
      params['productoq'] = searchProducto[index];
    }
    if (prop === 'pq_id_unidad') {
      params['unidadq'] = searchUnidad[index];
    }

    let Res = await Http.get(`preguia/detalle/form?${objectAsParams(params)}`);
    if (!Res.error) {
      if (Res.data.carga_tipos) {
        carga_tipos = Res.data.carga_tipos;
      }
      if (Res.data.embalaje_grupos) {
        embalaje_grupos = Res.data.embalaje_grupos;
      }
      if (Res.data.embalajes && Res.data.embalajes.length > 0) {
        embalajes = Res.data.embalajes;
      }
      if (Res.data.sucursales) {
        sucursales = Res.data.sucursales;
      }
      if (!initial) {
        if (Res.data.unidades) {
          searchUnidadOptions[index] = Res.data.unidades;
        }
        if (Res.data.productos) {
          searchProductoOptions[index] = Res.data.productos;
        }
      } else {
        if (Res.data.unidades && Res.data.productos) {
          for (let index = 0; index < paquetes.length; index++) {
            searchUnidadOptions[index] = Res.data.unidades;
            searchProductoOptions[index] = Res.data.productos;
            searchProducto[index] = Res.data.productos.filter(prod => prod.id === paquetes[index].pq_id_producto)[0].label;
            searchUnidad[index] = Res.data.unidades.filter(prod => prod.id === paquetes[index].pq_id_unidad)[0].label;
          }
        }
      }
    }
    this.setState({
      carga_tipos,
      embalaje_grupos,
      embalajes,
      sucursales,
      searchProductoOptions,
      searchUnidadOptions,
    });
  }

  paqueteAutocompleChange = (i, prop, value) => {
    let { searchProducto, searchUnidad } = this.state;
    if (value !== 0 && value.length > 0) {
      if (prop === 'pq_id_producto') {
        searchProducto[i] = value;
        this.setState({ searchProducto });
      } else if (prop === 'pq_id_unidad') {
        searchUnidad[i] = value;
        this.setState({ searchUnidad });
      }
  
      if (value.length > 1) { 
        this.getFormData({ index: i, prop });
      }
    }
  }

  agregarPaquete = () => {
    let paquetes = this.state.paquetes;
    paquetes.push({
      id_sucursal: 2,
      pq_cantidad: 1,
      pq_peso: 1,
      id_embalaje: '',
      pq_descripcion: '',
      pq_id_producto: '',
      pq_id_unidad: '',
    })
    this.setState({ paquetes })
  }

  paqueteChange = (i, prop, value) => {
    let { paquetes, pg_peso } = this.state;
    paquetes[i][prop] = value;
    pg_peso = paquetes.map(paq => paq.pq_peso).reduce((paq, current) => Number(paq) + Number(current));

    this.setState({ paquetes, pg_peso });
  }

  paqueteDelete = (idx) => {
    let paquetes = this.state.paquetes.filter((p, i) => (i !== idx));
    // console.log(paquetes)
    this.setState({ paquetes })
  }

  onSumbit = async () => {
    const { 
      id_grupo_embalaje, 
      paquetes,
      pg_observaciones, 
      pg_peso, 
      pg_ser_recoleccion, 
      pg_ser_entrega, 
      pg_ser_seguro, 
      pg_valor_declarado,
      productos,
    } = this.state;
    this.setState({ disabledButton: true })
    await this.props.onSave({
      id_grupo_embalaje, 
      paquetes, 
      pg_observaciones, 
      pg_peso, 
      pg_ser_recoleccion, 
      pg_ser_entrega, 
      pg_ser_seguro, 
      pg_valor_declarado,
      productos,
    });
    this.setState({ disabledButton: false });
  }

  onProductosChange = (productos) => {
    this.setState({ productos });
  }

  render() {
    const { id_grupo_embalaje, paquetes,
       pg_observaciones, pg_peso, sucursales, 
       embalajes, embalaje_grupos, disabledButton,
       searchProducto, searchProductoOptions, 
       searchUnidad, searchUnidadOptions, id, productos, showDetailProduct
    } = this.state;
    const { formDisabled } = this.props;
    return (
      <div style={{ padding: 10 }}>
        <FormControl variant="outlined" className='form-field' disabled={formDisabled} >
          <InputLabel>Tipo de carga</InputLabel>
          <Select
            value={id_grupo_embalaje}
            onChange={(e) => { this.setState({ id_grupo_embalaje: e.target.value }); this.getFormData({eg: e.target.value}) }}
          >
            {embalaje_grupos.map((carga, i) => (
              <MenuItem value={carga.id} key={i}>{carga.grupo}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <div style={{ textAlign: 'right', paddingTop: 10, paddingBottom: 10 }}>
          <Button variant="contained" color="primary"  disabled={formDisabled} onClick={this.agregarPaquete}>Agregar paquete</Button>
        </div>
        <div className='preguia-detalles-paquetes'>
          {paquetes.map((paquete, i) => (
            <div className='row paq in' key={i}>
              <div className='col-12 col-sm-1'>
                <FormControl variant="outlined" className='form-field' disabled={formDisabled}>
                  <InputLabel>Destino</InputLabel>
                  <Select
                    value={paquete.id_sucursal}
                    onChange={(e) => { this.paqueteChange(i, 'id_sucursal', e.target.value) }}
                  >
                    {sucursales.map((sucursal, i) => (
                      <MenuItem value={sucursal.id} key={i}>{sucursal.sucursal}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div className='col-12 col-sm-1'>
                <TextField 
                  disabled={formDisabled} 
                  type='number'
                  label="Cantidad" 
                  value={paquete.pq_cantidad} 
                  variant="outlined" 
                  inputProps={{ min: 1 }}
                  onChange={(e) => { this.paqueteChange(i, 'pq_cantidad', e.target.value) }}
                />
              </div>
              <div className='col-12 col-sm-1'>
                <TextField 
                  disabled={formDisabled} 
                  type='number'
                  label="Peso (KG)" 
                  value={paquete.pq_peso}
                  inputProps={{ min: 1 }} 
                  variant="outlined" 
                  onChange={(e) => { this.paqueteChange(i, 'pq_peso', e.target.value) }}
                />
              </div>
              <div className='col-12 col-sm-2'>
                <FormControl disabled={formDisabled} variant="outlined" className='form-field'>
                  <InputLabel>Embalaje</InputLabel>
                  <Select
                    value={paquete.id_embalaje}
                    onChange={(e) => { this.paqueteChange(i, 'id_embalaje', e.target.value) }}
                  >
                    {embalajes.map((embalaje, i) => (
                      <MenuItem value={embalaje.id} key={i}>{embalaje.embalaje}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div className="col-sm-2">
                <Autocomplete
                  disabled={formDisabled}
                  className='form-field'
                  inputValue={searchUnidad[i] ? searchUnidad[i] : ""}
                  getOptionLabel={(option) => option ? (option.label || '') : ''}
                  options={searchUnidadOptions[i] ? searchUnidadOptions[i] : []}
                  onInputChange={(e, newInputValue) => {
                    this.paqueteAutocompleChange(i, 'pq_id_unidad', newInputValue)
                  }}
                  value={paquete["pq_id_unidad"] ? paquete["pq_id_unidad"] : ""}
                  onChange={(event, newValue) => {
                    this.paqueteChange(i, "pq_id_unidad", newValue ? newValue.id : '');
                  }}
                  renderInput={params => (
                    <TextField {...params}
                      label={`Unidad`} 
                      variant="outlined" 
                      fullWidth
                      // onBlur={(e) => { this.fieldBlur(formField, e) }} 
                      />
                  )}
                />
              </div>
              <div className="col-sm-2">
                <Autocomplete
                  disabled={formDisabled}
                  className='form-field'
                  value={paquete["pq_id_producto"] ? paquete["pq_id_producto"] : ''}
                  onChange={(event, newValue) => {
                    this.paqueteChange(i, "pq_id_producto", newValue ? newValue.id : '');
                  }}
                  inputValue={searchProducto[i] ? searchProducto[i] : ''}
                  getOptionLabel={(option) => option ? (option.label || '') : ''}
                  options={searchProductoOptions ? (searchProductoOptions[i] ? searchProductoOptions[i] : []) : []}
                  onInputChange={(e, newInputValue) => {
                    this.paqueteAutocompleChange(i, 'pq_id_producto', newInputValue)
                  }}
                  renderInput={params => (
                    <TextField {...params}
                      label={`Producto`} 
                      variant="outlined" 
                      fullWidth
                      // onBlur={(e) => { this.fieldBlur(formField, e) }} 
                      />
                  )}
                />
              </div>
              <div className='col-12 col-sm-4'>
                <TextField
                  disabled={formDisabled}
                  label="Descripción"
                  multiline
                  fullWidth
                  minRows="1"
                  value={paquete.pq_descripcion}
                  onChange={(e) => { this.paqueteChange(i, 'pq_descripcion', e.target.value) }}
                  variant="outlined"
                />
              </div>
              <div className='col-12 col-sm-1 preguia-detalles-delete'>
                <IconButton onClick={() => { this.paqueteDelete(i) }}  disabled={formDisabled}>
                  <Icon>remove_circle</Icon>
                </IconButton>
              </div>
            </div>
          ))}
          {paquetes.length < 1 &&
            <span style={{ textAlign: "center" }} >NO HAY PAQUETES</span>
          }
        </div>
        <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
          <Button color="primary" onClick={() => { this.setState({ showDetailProduct: !showDetailProduct }) }} >
            Detallar Productos
          </Button>
        </div>
        {
          showDetailProduct && 
          <div className='preguia-detalles-paquetes'>
            <PreguiaProductos
              idpreguia={id}
              sucursales={sucursales} 
              embalajes={embalajes} 
              paquetes={paquetes}
              productos={productos}
              onProductosChange={this.onProductosChange}
            />
        </div>
        }
        <div>
          <div style={{ paddingTop: 5, paddingBottom: 5 }}>
            <TextField
              disabled={formDisabled}
              label="Observaciones"
              multiline
              fullWidth
              minRows="3"
              value={pg_observaciones}
              onChange={(e) => this.setState({ pg_observaciones: e.target.value })}
              variant="outlined"
            />
          </div>
          <div style={{ paddingTop: 5, paddingBottom: 5 }}>
            <TextField  disabled={formDisabled} type='number' label="Peso Total (KG)" value={pg_peso} variant="outlined" onChange={(e) => this.setState({ pg_peso: e.target.value })} fullWidth />
          </div>
        </div>
        <div style={{ textAlign: 'center' }}>
          <Button 
            disabled={disabledButton}
            variant="contained" 
            color="primary" 
            onClick={this.onSumbit}>
            Guardar
          </Button>
        </div>
      </div>
    )
  }
}
